export const extensions = {
    generali: 'Generali',
    allianz: 'Allianz',
    groupama: 'Groupama',
    zurich: 'Zurich',
    itas: 'Itas',
    mappa_sopralluoghi: 'Mappa Sopralluoghi',
    disabled_accertatore_incaricato: 'Disabilitare Accertatore Incaricato',
    deep_property: 'Deep Property',
    reale: 'Reale',
    italiana: 'Italiana',
    unipol: 'Unipol',
    chat_agenzia_liquidatore: 'Chat Agenzia Liquidatore'
}
